import css from "styled-jsx/css";

export const componentStyles = css`
  .testimonial {
  }

  .content {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .quote {
    font-size: 30px;
  }

  .author {
    font-size: 16px;
  }

  .company {
    font-weight: bold;
    font-size: 16px;
  }
`;
